import React from 'react';
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {MegaHeaderModuleController} from "../mega-header-module.controller";
import {MegaHeaderModuleProps} from "../models/mega-header-module.props";
import {MegaHeaderModuleDesktop} from "./mega-header-module.desktop";
import {MegaHeaderModuleMobile} from "./mega-header-module.mobile";

export class MegaHeaderModuleComponentProps extends MegaHeaderModuleProps {
}

export const MegaHeaderModuleComponent = ({controller}: MegaHeaderModuleComponentProps) => {
  const {state, device} = controller;
  const {isVisible} = state;
  const {isSmallView} = device;

  return isVisible ? (isSmallView ? <MegaHeaderModuleMobile controller={controller}/> : <MegaHeaderModuleDesktop controller={controller}/>) : null
};

const settings: ComposeSettings = {
  component: MegaHeaderModuleComponent,
  propsType: MegaHeaderModuleComponentProps,
  controllerType: MegaHeaderModuleController,
  createModule: true,
  observe: true,
}

export default Compose(settings);
